// extracted by mini-css-extract-plugin
module.exports = {"info":"Theme_info__2Z_Io","link":"Theme_link__1a0fo","label":"Theme_label__REqAJ"};